var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { MenuItem } from './menu-item';
var cls = classNames('utility-menu');
export var UtilityMenuDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 1em;\n  "], ["\n    width: 100%;\n    font-size: 1em;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(MenuItem)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
/* @ts-ignore */
export var UtilityMenu = React.forwardRef(function (props, ref) {
  var className = props.className,
    _a = props.items,
    items = _a === void 0 ? [] : _a,
    onItemClick = props.onItemClick,
    iconSize = props.iconSize;
  var handleClick = function (e) {
    if (onItemClick) {
      onItemClick(e);
    }
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, items.map(function (type) {
    return React.createElement(My.Item, {
      onClick: handleClick,
      href: type.path,
      // iconComponent={ICONS[type]}
      label: type.name,
      key: type.id
    });
  }));
});
UtilityMenu.cls = cls;
UtilityMenu.defaultProps = UtilityMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;